"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var clsx_1 = __importDefault(require("clsx"));
var notifier_1 = __importDefault(require("@utils/notifier"));
var SingleSelect_1 = __importDefault(require("@common/components/SingleSelect"));
var dictionaries_1 = require("@common/services/dictionaries");
var apiService_1 = __importDefault(require("../../services/apiService"));
function QuickAddToListBase(_a) {
    var _b;
    var domain = _a.domain, word = _a.word, label = _a.label, kind = _a.kind, automationListsPermission = _a.automationListsPermission, spanClassName = _a.spanClassName, singleSelectClassName = _a.singleSelectClassName;
    if (automationListsPermission === null || automationListsPermission === void 0 ? void 0 : automationListsPermission.canWrite) {
        var t_1 = (0, react_i18next_1.useTranslation)().t;
        var data = (0, dictionaries_1.useGetDictionariesQuery)({ domain: domain, kind: kind }).data;
        var dictionaries = ((_b = data === null || data === void 0 ? void 0 : data.results) === null || _b === void 0 ? void 0 : _b.map(function (dictionary) { return ({
            id: dictionary.name,
            text: dictionary.name,
        }); })) || [];
        var _c = __read((0, react_1.useState)(false), 2), showSearchList_1 = _c[0], setShowSearchList_1 = _c[1];
        var quickAddToListContainerRef_1 = (0, react_1.createRef)();
        var escapeOrTabPress_1 = function (_a) {
            var key = _a.key;
            if (key === 'Escape' || key === 'Tab') {
                setShowSearchList_1(false);
            }
        };
        (0, react_1.useEffect)(function () {
            var _a;
            (_a = quickAddToListContainerRef_1.current) === null || _a === void 0 ? void 0 : _a.addEventListener('keydown', escapeOrTabPress_1);
            return function () {
                var _a;
                (_a = quickAddToListContainerRef_1.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('keydown', escapeOrTabPress_1);
            };
        });
        var handleItemSelect_1 = function (item) {
            if (item !== null) {
                setShowSearchList_1(false);
                var listName_1 = item.id;
                apiService_1.default.patchFiltersDictionariesItems({ domain: domain, listName: listName_1 }, { item: word, kind: kind }).then(function () {
                    notifier_1.default.display(t_1('ITEM.QUICK_ADD_TO_LIST.SUCCESS_MESSAGE_REACT', {
                        NAME: label,
                        VALUE: word,
                        LIST_NAME: listName_1,
                    }), { type: 'success', duration: 1800 });
                }, function (error) {
                    var msg = error.status === 409
                        ? t_1('ITEM.QUICK_ADD_TO_LIST.DUPLICATE_ERROR_MESSAGE_REACT', {
                            NAME: label,
                            VALUE: word,
                            LIST_NAME: listName_1,
                        })
                        : t_1('ITEM.QUICK_ADD_TO_LIST.DUPLICATE_ERROR_MESSAGE_REACT', {
                            LIST_NAME: listName_1,
                        });
                    notifier_1.default.display(msg, { type: 'failure', duration: 6000 });
                });
            }
        };
        return (react_1.default.createElement("div", { 
            // For QuickAddToImage we want to keep the SingleSelect opened on mouse leave
            onMouseLeave: function () { return kind === 'MIXED' && setShowSearchList_1(false); }, className: (0, clsx_1.default)('quick-add-to-list', showSearchList_1 && 'quick-add-to-list--open'), ref: quickAddToListContainerRef_1, 
            // this is necessary for QuickAddToImage to prevent opening Media Gallery
            onClick: function (e) { return e.stopPropagation(); } },
            react_1.default.createElement("span", { className: spanClassName, onClick: function () { return setShowSearchList_1(!showSearchList_1); } },
                react_1.default.createElement("span", { className: "eva-tooltip" }, t_1('ITEM.QUICK_ADD_TO_LIST.TOOLTIP'))),
            showSearchList_1 && (react_1.default.createElement(SingleSelect_1.default, { getOptionLabel: function (_a) {
                    var text = _a.text;
                    return text;
                }, getOptionValue: function (_a) {
                    var id = _a.id;
                    return id;
                }, options: dictionaries, onChange: function (selectedOption) { return handleItemSelect_1(selectedOption); }, className: singleSelectClassName, defaultMenuIsOpen: true, isMenuPositionStatic: true, isSearchable: true, autoFocus: true, withSearchInputIcon: true }))));
    }
}
exports.default = QuickAddToListBase;
